import api from '../../api';
import { push } from 'connected-react-router';
import { store as storeNotification } from 'react-notifications-component';
import { socket } from './../store/socket';

const notificationConfig = {
  container: 'top-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 1500,
    showIcon: true
  }
};

export const categoriesStartRequest = () => {
  return {
    type: 'CATEGORIES_START_REQUEST'
  };
};

export const categoriesEndRequest = () => {
  return {
    type: 'CATEGORIES_END_REQUEST'
  };
};

export const getAllCategoriesSuccess = ({ data }) => {
  return {
    type: 'CATEGORIES_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllCategoriesError = error => {
  return {
    type: 'CATEGORIES_GET_ALL_ERROR',
    payload: error
  };
};

export const addCategoriesSuccess = ({ data }) => {
  return {
    type: 'CATEGORIES_ADD_SUCCESS',
    payload: data
  };
};

export const addCategoriesError = error => {
  return {
    type: 'CATEGORIES_ADD_ERROR',
    payload: error
  };
};

export const editCategoriesSuccess = ({ data }) => {
  return {
    type: 'CATEGORIES_EDIT_SUCCESS',
    payload: data
  };
};

export const editCategoriesError = error => {
  return {
    type: 'CATEGORIES_EDIT_ERROR',
    payload: error
  };
};

export const removeCategoriesSuccess = id => {
  return {
    type: 'CATEGORIES_REMOVE_SUCCESS',
    payload: id
  };
};

export const removeCategoriesError = error => {
  return {
    type: 'CATEGORIES_REMOVE_ERROR',
    payload: error
  };
};

export const categoriesModifyStore = ({ data }) => {
  return {
    type: 'CATEGORIES_MODIFY_STORE',
    payload: data
  };
};

export const addCategories = (data, formReset, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(categoriesStartRequest());
      const response = await api().post('/api/categories', data);
      dispatch(addCategoriesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'ADD',
        module: 'categories',
        data: [response.data],
        company: response.data.company
      });
      formReset();
    } catch (err) {
      dispatch(addCategoriesError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(categoriesEndRequest());
        submitBtn.disabled = false;
      }, 1800);
    }
  };
};

export const getAllCategories = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(categoriesStartRequest());
      const response = await api().get('/api/categories', { params });
      dispatch(getAllCategoriesSuccess(response));
    } catch (err) {
      dispatch(getAllCategoriesError(err));
    } finally {
      dispatch(categoriesEndRequest());
    }
  };
};

export const editCategories = (data, submitBtn = {}, handleModalClose) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(categoriesEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(categoriesStartRequest());
      const id = data._id;
      const response = await api().put('/api/categories/' + id, data);
      dispatch(editCategoriesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'categories',
        data: [response.data],
        company: response.data.company
      });
      await defaultMsg(submitBtn);
      if (handleModalClose) {
        handleModalClose();
      } else {
        dispatch(push('/categories'));
      }
    } catch (err) {
      dispatch(editCategoriesError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const removeCategories = id => {
  return async dispatch => {
    try {
      dispatch(categoriesStartRequest());
      await api().delete('/api/categories/' + id);
      dispatch(removeCategoriesSuccess(id));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'REMOVE',
        module: 'categories',
        data: id
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Categoria removido com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(removeCategoriesError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao remover categoria.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(categoriesEndRequest());
    }
  };
};

export const restoreCategories = data => {
  return async dispatch => {
    try {
      dispatch(categoriesStartRequest());
      const id = data._id;
      const response = await api().put('/api/categories/' + id, data);
      dispatch(editCategoriesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'RESTORE',
        module: 'categories',
        data: [response.data],
        company: response.data.company
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Categoria restaurado com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(editCategoriesError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao restaurar categoria.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(categoriesEndRequest());
    }
  };
};
